const ExecutionBrifAndWorkOrderTemplateName = {
  DealerAdvertising: "BRANCH TEMPLATE",
  EDM: "GENERAL TEMPLATE",
  InStoreDigital: "INSTORE DIGITAL TEMPLATE",
  InStorePrint: "INSTORE PRINT TEMPLATE",
  PaidMedia: "PAID MEDIA TEMPLATE",
  Simple: "SIMPLE TEMPLATE",
  Web: "WEB TEMPLATE",
};

export const TemplateName = {
  CampaignBrief: {
    General: "GENERAL TEMPLATE",
    Brand: "BRAND TEMPLATE",
    NewProductLaunch: "NEW PRODUCT TEMPLATE",
    SimpleSingleAsset: "SIMPLE SINGLE ASSET TEMPLATE",
  },
  ExecutionBrief: ExecutionBrifAndWorkOrderTemplateName,
  WorkOrder: ExecutionBrifAndWorkOrderTemplateName,
};
